<template lang="pug">
#lista-operacao
    BaseHeader(
        titulo='Operações',
        icon='el-icon-circle-plus-outline',
        btnTexto='Nova operação',
        :exibeBotao='true',
        @btnHeaderClicado='novaOperacao'
    )

    .view-container-base-header
        section.lista-operacao__barra-pesquisa
            i.el-icon-search
            input.lista-operacao__barra-pesquisa__input(
                v-model='filtro',
                type='text',
                placeholder='Pesquisa inteligente (Busque por CPF, CNPJ, CAR, Identificador, Número do contrato, Nome do Território, Pessoa ou Operação)',
                autocomplete='off',
                @keyup.enter='buscarOperacoes(0)'
            )

        section.lista-operacao__filtros
            span.lista-operacao__filtros__titulo Selecione uma situação para visualizar as operações

            el-skeleton.d-flex(
                :rows='1',
                :loading='buscandoFiltrosStatus',
                animated,
                style='justify-content: space-between'
            )
                template(slot='template')
                    el-skeleton-item
                template
                    .d-flex
                        .lista-operacao__filtros__item(
                            v-for='(filtroStatus, index) in status',
                            :key='index',
                            @click='buscarOperacoesPorStatus(filtroStatus)',
                            :class='filtroStatus.ativo ? "filtro-ativo" : "filtro-inativo"'
                        ) {{ filtroStatus.nome }}

                    el-checkbox(
                        style='display: flex; align-items: center',
                        v-model='filtrarOperacoesComAlertas',
                        @change='buscarOperacoes(0)'
                    ) Mostrar apenas operações com alertas

        section.lista-operacao__tabela
            el-table(
                :data='operacoes',
                stripe,
                height='calc(100% - 48px)',
                @sort-change='ordenar'
            )
                el-table-column(type='expand')
                    template(slot-scope='props')
                        .box-expande-listagem
                            .box-expande-listagem-box
                                .box-expande-listagem-box-texto
                                    | Atividades
                                .box-expande-listagem-box-value
                                    div(
                                        v-for='atividade in props.row.atividades',
                                        :key='atividade.id'
                                    )
                                        | {{ atividade.produto }} - {{ atividade.tipo }}

                            .box-expande-listagem-box
                                .box-expande-listagem-box-texto
                                    | Pessoas vinculadas
                                .box-expande-listagem-box-value
                                    div(
                                        v-for='pessoa in props.row.pessoasVinculadas',
                                        :key='pessoa.id'
                                    )
                                        | {{ pessoa.nome }} - {{ pessoa.papel }}

                            .box-expande-listagem-box
                                .box-expande-listagem-box-texto
                                    | CARs
                                .box-expande-listagem-box-value(
                                    v-if='props.row.territorios !== null && props.row.territorios.length > 0'
                                )
                                    div(
                                        v-for='(territorio, index) in props.row.territorios',
                                        :key='territorio.id'
                                    )
                                        .pb-2(v-if='index === 0') {{ territorio.nome }}
                                        .py-2(v-else) {{ territorio.nome }}
                                        div(
                                            v-for='(car, index) in territorio.cars',
                                            :key='index'
                                        )
                                            div {{ car }}
                                .pl-1(v-else) --

                el-table-column(label='Identificador')
                    template(slot-scope='scope')
                        span {{ scope.row.identificador ? scope.row.identificador : '--' }}
                        span.alerta(v-if='scope.row.possuiAlertas')
                            | Alerta

                el-table-column(label='Nome', sortable)
                    template(slot-scope='scope')
                        span {{ scope.row.nome }}

                el-table-column(
                    label='Data liberação',
                    align='center',
                    sortable
                )
                    template(slot-scope='scope')
                        span {{ scope.row.dataLiberacao }}

                el-table-column(label='Vigência', align='center', sortable)
                    template(slot-scope='scope')
                        span {{ scope.row.vigencia }}

                el-table-column(label='Número do contrato', align='center')
                    template(slot-scope='scope')
                        span {{ scope.row.numeroContrato ? scope.row.numeroContrato : '--' }}

                el-table-column(label='Categoria', align='center')
                    template(slot-scope='scope')
                        span {{ scope.row.categoria ? scope.row.categoria : '--' }}

                el-table-column(label='Situação', align='center')
                    template(slot-scope='scope')
                        el-tag(:color='identificarCorStatus(scope.row.status)') {{ scope.row.status }}

                el-table-column(label='Ações', width='100', align='center')
                    template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    v-for='(acoes, index) in scope.row.acoesDisponiveis',
                                    :key='index',
                                    :icon='operacaoStatusAcoes[acoes].icone',
                                    @click.native='operacaoStatusAcoes[acoes].callback(scope.row)'
                                ) {{ operacaoStatusAcoes[acoes].nome }}

            .tabela-rodape
                .tabela-rodape--esquerda
                    p {{ paginacao.total }} operações

                .tabela-rodape--pagination
                    el-pagination(
                        small,
                        layout='prev, pager, next',
                        :page-size='paginacao.itensPorPagina',
                        :current-page.sync='paginacao.pagina',
                        :total='paginacao.total',
                        @current-change='buscarOperacoes(paginacao.pagina - 1)'
                    )

    ModalCancelamentoOperacao(
        :operacao='operacao',
        :show.sync='mostrarModalCancelamento',
        @cancelarOperacao='buscarOperacoes(0)'
    )

    ModalConfirmarInicioAnaliseOperacao(
        :operacao='operacao',
        :show.sync='mostrarModalConfirmarAnalise',
        @iniciarAnalise='analisarOperacao'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ModalCancelamentoOperacao from '@/components/operacao/gestao/ModalCancelamentoOperacao.vue';
import ModalConfirmarInicioAnaliseOperacao from '@/components/operacao/gestao/ModalConfirmarInicioAnaliseOperacao.vue';
import OperacaoService from '@/services/OperacaoService';
import OperacaoLaudoService from '@/services/OperacaoLaudoService';

export default {
    name: 'index',
    components: {
        BaseHeader,
        ModalConfirmarInicioAnaliseOperacao,
        ModalCancelamentoOperacao
    },
    data() {
        return {
            buscandoFiltrosStatus: false,
            filtro: '',
            filtrosStatus: [],
            filtrarOperacoesComAlertas: false,
            status: [],
            corStatus: {
                'Em análise': 'var(--operation-under-review)',
                'Aguardando aprovação': 'var(--operation-awaiting-approval)',
                Reprovado: 'var(--failed-operation)',
                Aprovado: 'var(--approved-list-operation)'
            },
            mostrarModalCancelamento: false,
            mostrarModalConfirmarAnalise: false,
            operacao: {},
            operacoes: [],
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            operacaoStatusAcoes: {
                ANALISAR: {
                    nome: 'Iniciar análise',
                    codigo: 'INICIAR_ANALISE',
                    icone: 'el-icon-finished',
                    callback: this.confirmarIniciarAnaliseOperacao
                },
                CANCELAR: {
                    nome: 'Cancelar',
                    codigo: 'CANCELAR',
                    icone: 'el-icon-circle-close',
                    callback: this.cancelarOperacao
                },
                CLONAR: {
                    nome: 'Clonar',
                    codigo: 'CLONAR',
                    icone: 'el-icon-document-copy',
                    callback: this.clonarOperacao
                },
                CONTINUAR_ANALISE: {
                    nome: 'Continuar análise',
                    codigo: 'CONTINUAR_ANALISE',
                    icone: 'el-icon-finished',
                    callback: this.analisarOperacao
                },
                EDITAR: {
                    nome: 'Editar',
                    codigo: 'EDITAR',
                    icone: 'el-icon-edit',
                    callback: this.editarOperacao
                },
                EXPORTAR_ANALISE: {
                    nome: 'Exportar análise socioambiental',
                    codigo: 'EXPORTAR_ANALISE',
                    icone: 'el-icon-picture-outline',
                    callback: this.exportarAnaliseSocioambiental
                },
                GERAR_ARQUIVO_XLSX: {
                    nome: 'Gerar arquivo de coordenadas Crédito Rural',
                    codigo: 'GERAR_ARQUIVO_XLSX',
                    icone: 'el-icon-download',
                    callback: this.gerarArquivoCoordenadasXLSX
                },
                GERAR_ARQUIVO_BNDES_XLSX: {
                    nome: 'Gerar arquivo de coordenadas BNDES',
                    codigo: 'GERAR_ARQUIVO_BNDES_XLSX',
                    icone: 'el-icon-download',
                    callback: this.gerarArquivoCoordenadasXLSXBndes
                },
                SOLICITAR_FISCALIZACAO: {
                    nome: 'Solicitar fiscalização',
                    codigo: 'SOLICITAR_FISCALIZACAO',
                    icone: 'el-icon-zoom-in',
                    callback: this.solicitarFiscalizacao
                },
                VISUALIZAR: {
                    nome: 'Visualizar',
                    codigo: 'VISUALIZAR',
                    icone: 'el-icon-view',
                    callback: this.visualizarOperacao
                },
                VISUALIZAR_MONITORAMENTO: {
                    nome: 'Monitoramento',
                    codigo: 'VISUALIZAR_MONITORAMENTO',
                    icone: 'el-icon-monitor',
                    callback: this.visualizarMonitoramento
                }
            }
        };
    },

    async mounted() {
        await this.buscarOperacoes(0);
        await this.buscarStatusFiltro();
    },

    methods: {
        analisarOperacao(operacao = null) {
            if (operacao) this.operacao = operacao;
            this.$router.push({
                name: 'operacaoAnalisar',
                params: { id: this.operacao.id }
            });
        },

        async solicitarFiscalizacao(operacao) {
            await OperacaoLaudoService.inserir({ idOperacao: operacao.id })
                .then(() => {
                    this.$notify.success({
                        message: 'Laudo de fiscalização solicitado com sucesso.'
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao solicitar fiscalização do laudo.'
                    });
                });
        },

        async buscarOperacoes(pagina) {
            this.paginacao.pagina = pagina;
            await OperacaoService.buscar(
                this.filtro,
                this.filtrosStatus,
                this.paginacao,
                this.filtrarOperacoesComAlertas
            ).then(({ data }) => {
                this.operacoes = data.itens;
                this.paginacao = data.paginacao;
                this.paginacao.pagina += 1;
            });
        },

        async buscarStatusFiltro() {
            this.buscandoFiltrosStatus = true;
            await OperacaoService.buscarStatusFiltro()
                .then(({ data }) => {
                    this.status = data.status;
                    this.status.forEach(status => (status.ativo = false));
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Erro ao buscar situações para filtro'
                    });
                })
                .finally(() => (this.buscandoFiltrosStatus = false));
        },

        buscarOperacoesPorStatus(filtroStatus) {
            if (filtroStatus.ativo) {
                filtroStatus.ativo = false;
                this.filtrosStatus = this.filtrosStatus.filter(
                    item => item !== filtroStatus.codigo
                );
            } else {
                filtroStatus.ativo = true;
                this.filtrosStatus.push(filtroStatus.codigo);
            }

            this.buscarOperacoes(0);
        },

        cancelarOperacao(operacao) {
            this.operacao = operacao;
            this.mostrarModalCancelamento = true;
        },

        clonarOperacao(operacao) {
            this.$router.push({
                name: 'operacaoClonar',
                params: { id: operacao.id, acao: 'clonar' }
            });
        },

        confirmarIniciarAnaliseOperacao(operacao) {
            this.operacao = operacao;
            this.mostrarModalConfirmarAnalise = true;
        },

        editarOperacao(operacao) {
            this.$router.push({
                name: 'operacaoEditar',
                params: { id: operacao.id, acao: 'editar' }
            });
        },

        async exportarAnaliseSocioambiental(operacao) {
            try {
                await OperacaoService.exportarAnalise(operacao.id);

                this.$notify.success({
                    message: 'Análise exportada com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao exportar a análise!'
                });
            }
        },

        ordenar(props) {
            this.paginacao.direcao = props.order;
            this.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.paginacao.ordernarPor = null;
            this.buscarOperacoes(0);
        },

        async gerarArquivoCoordenadasXLSX(operacao) {
            try {
                await OperacaoService.baixarCoordenadasExcel(operacao.id);

                this.$notify.success({
                    message: 'Download realizado com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar download!'
                });
            }
        },

        async gerarArquivoCoordenadasXLSXBndes(operacao) {
            try {
                await OperacaoService.baixarCoordenadasExcelBndes(operacao.id);

                this.$notify.success({
                    message: 'Download realizado com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao realizar download!'
                });
            }
        },

        identificarCorStatus(status) {
            return this.corStatus[status];
        },

        novaOperacao() {
            this.$router.push({ name: 'operacaoCadastrar' });
        },

        visualizarOperacao(operacao) {
            this.$router.push({
                name: 'operacaoVisualizar',
                params: { id: operacao.id, operacao }
            });
        },

        visualizarMonitoramento(operacao) {
            this.$router.push({
                name: 'operacaoMonitoramento',
                params: { id: operacao.id, operacao }
            });
        }
    }
};
</script>

<style lang="scss">
#lista-operacao {
    height: 100%;
    width: 100%;

    .lista-operacao__barra-pesquisa {
        height: 46px;
        border-radius: 5px;
        color: var(--primary);
        margin-bottom: 20px;
        background-color: var(--white);
        display: flex;
        justify-content: center;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        i.el-icon-search {
            color: var(--primary);
            font-size: 25px;
            font-weight: bold;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        .lista-operacao__barra-pesquisa__input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .lista-operacao__filtros {
        height: 64px;
        margin-bottom: 20px;

        .lista-operacao__filtros__titulo {
            font-size: map-get($font-size, big);
            color: var(--primary-font-color);
        }

        .lista-operacao__filtros__item {
            transition: all 0.3s ease-in-out;
            font-weight: map-get($font-weight, normal);
            font-size: map-get($font-size, small);
            align-items: center;
            display: flex;
            padding: 0 20px;
            height: 35px;
            cursor: pointer;
            border-radius: 30px;
            margin-right: 15px;
            margin-top: 5px;
            box-shadow: 0 1px 5px 0 var(--block-shadow);
        }

        .filtro-ativo {
            background-color: var(--primary);
            color: var(--white);
        }

        .filtro-inativo {
            background-color: var(--white);
            color: var(--primary);
        }
    }

    .lista-operacao__tabela {
        border-radius: 5px;
        height: calc(100vh - 356px);
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            height: calc(100% - 54px);
            width: 100%;
        }

        .el-table th {
            font-weight: bold;
            font-size: 14px;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            margin-top: 8px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }

        .box-expande-listagem {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-top: 15px;
            margin-bottom: 15px;
            padding: 0 18px;

            .box-expande-listagem-box {
                width: 33%;

                .box-expande-listagem-box-texto {
                    font-weight: 600;
                    color: var(--primary);
                }

                .box-expande-listagem-box-value {
                    max-height: 75px;
                    overflow-y: auto;
                    font-weight: 400;
                    color: var(--primary);
                }
            }
        }
    }

    .alerta {
        margin-left: 7px;
        font-weight: 500;
        background-color: var(--background-alert);
        color: var(--color-alert);
        border-radius: 5px;
        width: auto;
        padding: 3px 5px 3px 5px;
    }

    .el-skeleton__text {
        height: 35px;
        width: 35%;
    }

    .el-tag {
        border-radius: 20px !important;
        border: none !important;
        text-align: center;
    }
}
</style>
